import { logout } from '../../api/auth';
import { clearSession } from '../../api/session-store';
import { ChangePasswordForm } from '../../components/account/ChangePasswordForm';
import { useSession } from '../../hooks/use-session';

/**
 * Shown instead of the whole app while the user is on a temporary password
 * (new account, or a reset): the server refuses every other API call with
 * 403 `password_change_required` until the password is replaced.
 */
export function ForcePasswordChangePage() {
  const { me } = useSession();

  async function handleLogout() {
    try {
      await logout();
    } finally {
      clearSession();
      window.location.assign('/');
    }
  }

  return (
    <div className="flex h-full items-center justify-center bg-muted/40">
      <div className="w-96 rounded border border-border bg-card p-6 shadow-sm">
        <h1 className="mb-1 text-lg font-semibold">Смените временный пароль</h1>
        <p className="mb-4 text-sm text-muted-fg">
          Вы вошли с временным паролем{me?.user.email ? ` (${me.user.email})` : ''}. Чтобы продолжить работу, задайте
          свой — временный после этого перестанет действовать.
        </p>
        <ChangePasswordForm email={me?.user.email} currentLabel="Временный пароль" submitLabel="Сохранить и продолжить" />
        <button type="button" className="mt-4 text-xs text-muted-fg underline" onClick={() => void handleLogout()}>
          Выйти
        </button>
      </div>
    </div>
  );
}
